// * ©2018 EdgeVerve Systems Limited, Bangalore, India. All Rights Reserved.
// *
// * The EdgeVerve proprietary software program ("Program"), is protected by copyrights laws, international treaties
// * and other pending or existing intellectual property rights in India, the United States and other countries. The Program
// * may contain / reference third party or open source components, the rights to which continue to remain with the applicable
// * third party licensors or the open source community as the case may be and nothing here transfers the rights to the third party
// * and open source components, except as expressly permitted. Any unauthorized reproduction, storage, transmission in any
// * form or by any means (including without limitation to electronic, mechanical, printing, photocopying, recording or 
// * otherwise), or any distribution of this Program, or any portion of it, may result in severe civil and criminal penalties, and will be
// * prosecuted to the maximum extent possible under the law.
import { Directive, ElementRef, HostListener, Output, Input } from '@angular/core';

import { HeaderService } from '../../core/services/header.service';
import { EventEmitter } from 'events';
@Directive({
    selector: '[appOutsideClick]',
    standalone: false
})
export class OutsideClickDirective {

  constructor(public el: ElementRef, public _headerService: HeaderService) { }

  @HostListener('mouseleave') onMouseLeave() {
    this._headerService.hideIconsOverlay();
  }

  @Input() show;

  @HostListener('document:click', ['$event.target'])
  public onClick(targetElement) {
    if (!this.show) {
      return;
    }
    var clickedInside
    if (this.el.nativeElement.id === "cartIcon") {
      clickedInside = this.el.nativeElement.contains(targetElement) || this.el.nativeElement.parentNode.previousElementSibling.contains(targetElement);
    }
    if (this.el.nativeElement.id === "notificationIcon") {
      clickedInside = this.el.nativeElement.contains(targetElement) || this.el.nativeElement.parentNode.previousElementSibling.contains(targetElement);
    }
    if (this.el.nativeElement.id === "appSwitcherIcon") {
      clickedInside = this.el.nativeElement.contains(targetElement) || this.el.nativeElement.parentNode.previousElementSibling.contains(targetElement);
    }
    if (this.el.nativeElement.id === "profileIcon") {
      clickedInside = this.el.nativeElement.contains(targetElement) || this.el.nativeElement.parentNode.previousElementSibling.contains(targetElement);
    }

    if (!clickedInside) {
      this._headerService.hideIconsOverlay();
    }
  }
}


